<template>
    <v-container class="pt-0 pb-5">
        <v-row>
            <v-col cols="12">
                <div class="pa-2 rounded elevation-1 bg-white d-flex flex-column ga-2">
                    <div>
                        <SportipsButton backButton chevronLeft>Retour</SportipsButton>
                    </div>
                    <v-progress-linear v-if="loading" indeterminate color="primary-dark"
                        class="mb-3"></v-progress-linear>
                    <v-alert v-else-if="error" type="error" variant="tonal" class="mb-3">
                        {{ error }}
                    </v-alert>
                    <div v-else-if="suiviData">
                        <div class="text-h5 font-weight-bold mb-3">
                            Suivi du groupe {{ suiviData.groupe?.nom }} (Code {{ suiviData.groupe?.token }})
                        </div>
                        <div class="text-h6 font-weight-bold mb-2">Informations du groupe</div>
                        <InformationsGroupe :groupe="suiviData.groupe"
                            @limite-updated="loadSuivi"></InformationsGroupe>

                        <div class="text-h6 font-weight-bold mb-2">Détail des inscriptions</div>


                        <div v-if="hasInscriptions" class="d-flex flex-column ga-3">
                            <ListInscriptionGroupe :inscriptions="suiviData.details"></ListInscriptionGroupe>
                        </div>
                        <v-alert v-else variant="tonal" color="info">
                            Aucune inscription pour le moment.
                        </v-alert>
                        <template v-if="canCloseGroupe">
                            <div class="text-h6 font-weight-bold mb-2 mt-4">Clôturer le groupe</div>
                            <CloseGroupeForm :groupe="suiviData.groupe" :totaux="suiviData.totaux"
                                :details="suiviData.details" @onClose="handleClose"></CloseGroupeForm>
                        </template>
                    </div>

                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PublicService from "@/services/public.service";
import InformationsGroupe from "@/components/Administration/LiensGroupeInscription/Suivi/InformationsGroupe.vue";
import ListInscriptionGroupe from "@/components/Administration/LiensGroupeInscription/Suivi/ListInscriptionGroupe.vue";
import CloseGroupeForm from "@/components/Administration/LiensGroupeInscription/Suivi/CloseGroupeForm.vue";
export default {
    components: { InformationsGroupe, ListInscriptionGroupe, CloseGroupeForm },
    data() {
        return {
            loading: true,
            error: null,
            suiviData: null,
        };
    },
    computed: {
        ...mapStores(useMainStore),
        hasInscriptions() {
            if (!this.suiviData?.details) return false;
            return Object.keys(this.suiviData.details).length > 0;
        },
        canCloseGroupe() {
            return this.mainStore.authAdmin?.isLogged && this.mainStore.authAdmin?.hasModuleAccess;
        },
    },
    methods: {
        async loadSuivi() {
            this.loading = true;
            this.error = null;
            this.suiviData = null;

            const token = this.$route.params.token;
            const id_module = this.mainStore.module?.id;

            if (!token || !id_module) {
                this.error = "Lien invalide ou module non chargé.";
                this.loading = false;
                return;
            }

            const res = await PublicService.getSuiviLienGroupe(token, id_module);

            if (!res) {
                this.error = "Impossible de charger les données. Vérifiez que le lien est valide.";
            } else {
                this.suiviData = res;
            }

            this.loading = false;
        },
        handleClose() {
            this.loadSuivi();
        },
    },
    async mounted() {
        await this.loadSuivi();
    },
    watch: {
        "$route.params.token"() {
            this.loadSuivi();
        },
    },
};
</script>

<style lang="scss" scoped>
.gap-2 {
    gap: 0.5rem;
}
</style>
